import { render, staticRenderFns } from "./SideRight_Image.vue?vue&type=template&id=4665b065"
import script from "./SideRight_Image.vue?vue&type=script&lang=js"
export * from "./SideRight_Image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports